export default {
  name: {
    label: 'Shop',
    placeholder: 'Add shop',
    system: {
      name: 'name',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'name',
    rules: {
      title: 'Shop field',
      required: true,
    }
  },
  owner: {
    label: 'Owner / Lead',
    placeholder: 'Add owner / lead',
    system: {
      name: 'owner',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'owner',
    rules: {
      title: 'Owner / Lead field',
      required: true,
    }
  },
  workers: {
    label: 'Select worker(s)',
    placeholder: '',
    system: {
      name: 'workers',
    },
    value: [],
    errors: [],
    type: 'text',
    name: 'workers',
    rules: {
      title: 'Select worker(s) field',
      required: false,
    }
  }
};



// WEBPACK FOOTER //
// ./src/containers/AddShop/fields.js